import { ArrowRight, PlayCircle, Award } from "lucide-react";
import useReveal from "@/hooks/useReveal";

const COLLAGE_URL =
  "https://static.prod-images.emergentagent.com/jobs/5f3cec3a-3dec-425c-ac43-979e18afef98/images/548a99b6c1edce24331281d499645991cce75c58d5d04fb1ee4d125c15d814de.jpeg";

export default function Hero() {
  const ref = useReveal();

  return (
    <section
      id="home"
      ref={ref}
      data-testid="hero-section"
      className="relative bg-[#B01116] overflow-hidden"
    >
      <div
        className="absolute inset-0 opacity-25"
        style={{
          background:
            "repeating-linear-gradient(135deg, transparent 0px, transparent 60px, rgba(0,0,0,0.12) 60px, rgba(0,0,0,0.12) 120px)",
        }}
        aria-hidden="true"
      />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20 lg:py-24 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-7 fade-up">
          <h1
            data-testid="hero-headline"
            className="font-display font-black text-4xl sm:text-5xl lg:text-6xl leading-[1.08] tracking-tight text-white"
          >
            <span className="text-[#FFC107]">We Build Growth Systems</span>
            <br />
            That Generate Leads &amp; Sales.
          </h1>

          <p
            data-testid="hero-subheadline"
            className="mt-6 max-w-xl text-base sm:text-lg text-white/85 leading-relaxed"
          >
            Performance Marketing | Funnels | AI Automation — helping ambitious
            businesses scale with strategies engineered for real, measurable revenue.
          </p>

          <div className="mt-9 flex flex-wrap items-center gap-4">
            <a href="#contact" data-testid="hero-primary-cta" className="btn-yellow gap-2">
              Book a Free Consultation
              <ArrowRight className="h-4 w-4" />
            </a>
            <a href="#services" data-testid="hero-secondary-cta" className="btn-outline-white gap-2">
              <PlayCircle className="h-4 w-4" />
              Explore Services
            </a>
          </div>
        </div>

        <div className="lg:col-span-5 fade-up relative" style={{ transitionDelay: "120ms" }}>
          <img
            src={COLLAGE_URL}
            alt="Gold Mind Business — marketing team delivering growth results"
            fetchPriority="high"
            decoding="async"
            width="1024"
            height="1024"
            className="w-full max-w-md mx-auto"
          />
          <div
            data-testid="hero-award-badge"
            className="absolute top-2 right-2 sm:top-4 sm:right-4 h-24 w-24 rounded-full bg-[#FFC107] border-4 border-white shadow-xl flex flex-col items-center justify-center text-center rotate-6"
          >
            <Award className="h-5 w-5 text-[#B01116]" />
            <div className="font-display font-black text-[#B01116] text-lg leading-none mt-0.5">3+</div>
            <div className="text-[0.5rem] font-accent font-bold text-[#7a2d00] uppercase tracking-wide leading-tight px-2">
              Years of Excellence
            </div>
          </div>
        </div>
      </div>

      <div data-testid="hero-ticker" className="relative bg-[#FFC107] py-3">
        <p className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center font-accent font-bold text-[#111827] text-sm sm:text-base">
          “Performance-Driven Digital Marketing | Delhi <span className="text-[#B01116]">&amp;</span> Across India”
        </p>
      </div>
    </section>
  );
}
